import { render, staticRenderFns } from "./ArticleTreeItem.vue?vue&type=template&id=563d1f21&scoped=true&"
import script from "./ArticleTreeItem.vue?vue&type=script&lang=js&"
export * from "./ArticleTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTreeItem.vue?vue&type=style&index=0&id=563d1f21&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d1f21",
  null
  
)

export default component.exports